import {get} from 'lodash'

export default {
  methods: {
    getErrorMessage ({response = {}, name = ''}) {
      const data = response.data
      const errorStatus = get(data, 'status', '')
      const errorsName = get(data, 'errors.name', errorStatus)
      const errorsMessage = get(data, 'errors.message', errorsName)
      const errorMessage = get(data, 'errors.error.message', errorsMessage)
      const message = typeof data === 'string' ? data : errorMessage
      return `${message}`
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/getErrorMessage.js